document.addEventListener("DOMContentLoaded", function () {
  // Valentine's: £30 off with code LOVE30 (fixed discount display only)
  const paddleBoardHandles = [
    // ALLROUND TEN 10' series
    "aquaplanet-allround-ten-10-inflatable-paddle-board-package-purple",
    "aquaplanet-allround-ten-10-inflatable-paddle-board-package-blue",
    "aquaplanet-allround-ten-10-inflatable-paddle-board-package-orange",
    // BOLT 9'4" series
    "aquaplanet-bolt-94-inflatable-paddle-board-package-blue",
    "aquaplanet-bolt-94-inflatable-paddle-board-package-coral",
    // ROCKIT 10'2" series
    "aquaplanet-rockit-10-2-inflatable-paddle-board-package-blue",
    "aquaplanet-rockit-10-2-inflatable-paddle-board-package-pink",
    // MAX 10'6" series (old + new colors)
    "aquaplanet-max-10-6-inflatable-paddle-board-package-blue",
    "aquaplanet-max-10-6-inflatable-paddle-board-package-orange",
    "aquaplanet-max-10-6-inflatable-paddle-board-package-rainbow",
    "aquaplanet-max-10-6-inflatable-paddle-board-package-prism",
    "aquaplanet-max-10-6-inflatable-paddle-board-package-glacier-v2",
    "aquaplanet-max-10-6-inflatable-paddle-board-package-sunrise",
    // MAX Plus 11'8" series
    "aquaplanet-max-plus-118-inflatable-sup-package-horizon",
    "aquaplanet-max-plus-118-inflatable-sup-package-beach",
    // PACE 10'6" series
    "aquaplanet-pace-sup-package-stand-up-inflatable-paddle-board-kit-10-6-long-teal-midnight",
    "aquaplanet-pace-sup-package-stand-up-inflatable-paddle-board-kit-10-6-long-red-blue",
    // Other Aquaplanet boards
    "aquaplanet-seeker-10-8-inflatable-paddle-board-package",
    "aquaplanet-jupiter-116-inflatable-paddle-board-package",
    "aquaplanet-cuda-expedition-14-inflatable-paddle-board-package",
    "aquaplanet-wingtail-9-inflatable-surf-sup-paddle-board-package",
    "aquaplanet-wilderness-adventure-108-inflatable-paddle-board-package",
    "aquaplanet-stinger-explorer-128-inflatable-paddle-board-package",
    // Hurley Advantage series
    "hurley-advantage-terrazzo-10-inflatable-paddle-board-package",
    "hurley-advantage-black-tiger-10-inflatable-paddle-board-package",
    "hurley-advantage-outsider-10-6-inflatable-paddle-board-package",
    // Hurley ApexTour series
    "hurley-apextour-malibu-118-inflatable-paddle-board-package",
    "hurley-apextour-freedom-118-inflatable-paddle-board-package"
  ];

  const DISCOUNT_AMOUNT = 30;

  function applyFixedDiscount(priceText, discountAmount) {
    const price = parseFloat(String(priceText).replace(/[^0-9.]/g, ""));
    if (Number.isNaN(price)) return null;

    const discountedPrice = Math.max(0, price - discountAmount);
    return `£${discountedPrice.toFixed(2)}`;
  }

  const urlParts = window.location.pathname.split("/").filter(Boolean);

  const isCollectionPage = urlParts.includes("collections") || window.location.pathname === "/";
  const isProductPage = urlParts.includes("products");

  if (isCollectionPage) {
    const productCards = document.querySelectorAll(".cl-product-card-inner-container");

    productCards.forEach((card) => {
      const productLink = card.querySelector("a[href*='/products/']");
      if (!productLink) return;

      const href = productLink.getAttribute("href") || "";
      const productHandle = href.split("/products/").pop()?.split("?")[0]?.split("#")[0];

      if (!productHandle || !paddleBoardHandles.includes(productHandle)) return;

      const priceElement = card.querySelector(".price-variation");
      if (!priceElement) return;

      const currentPriceText = priceElement.textContent || "";
      const discountedPrice = applyFixedDiscount(currentPriceText, DISCOUNT_AMOUNT);
      if (!discountedPrice) return;

      priceElement.textContent = `${discountedPrice} with code LOVE30`;
    });
  }

  if (isProductPage) {
    const productHandle = urlParts[urlParts.indexOf("products") + 1];
    if (!productHandle || !paddleBoardHandles.includes(productHandle)) return;

    const priceSnippet = document.querySelector(".product-details-price-snippet .sale-price");
    if (priceSnippet) {
      const currentPriceText = priceSnippet.textContent || "";
      const discountedPrice = applyFixedDiscount(currentPriceText, DISCOUNT_AMOUNT);
      if (discountedPrice) {
        priceSnippet.textContent = `${discountedPrice} with code LOVE30`;
      }
    }

    const formPrice = document.querySelector(".product-form-price .price");
    if (formPrice) {
      const currentPriceText = formPrice.textContent || "";
      const discountedPrice = applyFixedDiscount(currentPriceText, DISCOUNT_AMOUNT);
      if (discountedPrice) {
        formPrice.textContent = `${discountedPrice} with code LOVE30`;
      }
    }
  }
});